import { render, staticRenderFns } from "./SoCloseButton.vue?vue&type=template&id=586e72bf&scoped=true&"
import script from "./SoCloseButton.vue?vue&type=script&lang=js&"
export * from "./SoCloseButton.vue?vue&type=script&lang=js&"
import style0 from "./SoCloseButton.vue?vue&type=style&index=0&id=586e72bf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "586e72bf",
  null
  
)

export default component.exports